var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgLight = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 19,
    viewBox: "0 0 12 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1a202c",
    d: "M6 0C2.945 0 0 2.42 0 5.846c0 2.133.83 3.515 1.57 4.58.739 1.065 1.319 1.787 1.319 2.92v2.714c0 .891.728 1.583 1.555 1.583h.021C4.575 18.404 5.225 19 6 19c.775 0 1.425-.596 1.535-1.357h.02c.828 0 1.556-.692 1.556-1.583v-2.715c0-1.132.58-1.854 1.32-2.919C11.17 9.361 12 7.979 12 5.846 12 2.419 9.055 0 6 0zm0 1.357c2.366 0 4.667 1.86 4.667 4.489 0 1.794-.615 2.78-1.32 3.795-.601.866-1.316 1.775-1.514 3.026H4.167c-.198-1.25-.913-2.16-1.514-3.026-.705-1.015-1.32-2-1.32-3.795 0-2.628 2.301-4.489 4.667-4.489zm-.299.453c-2.208.262-3.923 2.184-3.923 4.495 0 .462.068.908.194 1.329.104.34.5.55.834.445.334-.105.547-.508.444-.848-.088-.294-.139-.602-.139-.926 0-1.631 1.195-2.962 2.743-3.145.344-.025.635-.357.618-.707-.07-.49-.382-.673-.77-.643zM4.222 14.024h3.556v.452H4.222v-.452zm0 1.81h3.556v.226c0 .147-.112.226-.222.226H4.444c-.11 0-.222-.079-.222-.226v-.227z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/light.c826d752.svg";
export { ForwardRef as ReactComponent };